import { Box, Button, Chip, Link, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

import styles from "./styles";

interface IButton {
  text: string;
  href: string;
}

interface IAction {
  label: string;
  text: string | ReactNode;
  onClick?: () => void;
  href?: string;
  buttonText?: string;
  buttons?: IButton[];
}

const EmptyReports: FC = () => {
  const actions: IAction[] = [
    {
      label: "Введите API-ключ от своего кабинета в Маркетплейсе",
      text: "Это быстро и безопасно! И уже через час мы загрузим карточки товаров, см. раздел «Товары».",
      buttons: [
        {
          text: "Инструкция",
          href: "https://docs.google.com/document/d/1XI8wEpJaqGgsJ7nxL1NZOHGi7aUP7TLa7QjZ2LD4h20"
        },
        {
          text: "Видео",
          href: "https://kinescope.io/n16E5RZ29CjyBQiTACjB39"
        }
      ]
    },
    {
      label: "Заполнить себестоимость и не только",
      text: "Мы рады предложить Вам интерфейс для удобного управления товарами, категориями, себестоимостью!",
      buttons: [
        {
          text: "Инструкция",
          href: "https://docs.google.com/document/d/19ziMZNxpl2YufkCakRdKOPrNaYk_niZdtHnusOjoOuE"
        },
        {
          text: "Видео",
          href: "https://disk.yandex.ru/i/SYB7urGGYc6gkA"
        }
      ]
    },
    {
      label: "На следующий день после регистрации Вы получаете доступ к базовым отчетам",
      text: "Увлекательное путешествие в мир финансовой аналитики начинается!",
      buttonText: "Ознакомиться с возможностями сервиса",
      href: "https://kinescope.io/sR6Uym8HdVFiy15f3yrPvU"
    },
    {
      label: "Получить консультацию специалиста",
      text: "Наши эксперты готовы помочь Вам разобраться в сервисе и ответить на любые вопросы!",
      buttonText: "Связаться с нами",
      href: "https://t.me/effstepsalesdir"
    },
    {
      label: "Я готов оплатить и хочу получить доступ!",
      text: "Напишите нам — подберем решения для Ваших задач и активируем полный доступ к отчетам. Обещаем, что Вы увидите, как данные работают на Вас!",
      buttonText: "Связаться с нами",
      href: "https://t.me/effstepsalesdir"
    },
    {
      label: "Я уже оплатил, что дальше?",
      text: "Отчеты будут доступны для использования уже на следующий день после ввода ключа! Наши финансовые консультанты помогут вам разобраться в цифрах, выполнить аудит вашего кабинета или провести сессию «Вопрос – ответ» в формате группового звонка.",
      buttonText: "Связаться с нами",
      href: "https://t.me/effstepsalesdir"
    }
  ];

  return (
    <Box sx={styles.root}>
      <Box sx={styles.textBlock}>
        <Box>
          <Typography sx={styles.title}>
            Меня зовут Баранова Анна, я сооснователь{" "}
            <Link
              href="https://kinescope.io/sR6Uym8HdVFiy15f3yrPvU"
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.link}
            >
              сервиса EFFSTEP
            </Link>
          </Typography>
          <Typography sx={styles.subtitle}>
            Рада видеть Вас в числе наших пользователей!
          </Typography>
          <Typography sx={styles.subtitle}>
            Пока у вас нет доступа к нашим аналитическим отчетам, но это временно 😊
          </Typography>
          <Typography sx={styles.subtitle}>
            Всем пользователям мы даём 7-дневный пробный период, для этого:
          </Typography>

          <Box mt={3}>
            {actions.map((action, index) => (
              <Box sx={styles.action} key={index}>
                <Box mr={2}>
                  <Chip
                    label={index + 1}
                    color="primary"
                    variant="outlined"
                    sx={styles.chip}
                  />
                </Box>
                <Box>
                  <Typography sx={styles.actionTitle}>{action.label}</Typography>
                  <Typography sx={styles.actionText}>{action.text}</Typography>
                  <Box sx={styles.buttonContainer}>
                    {action.buttons ? (
                      action.buttons.map((button, btnIndex) => (
                        <Button
                          key={btnIndex}
                          variant="contained"
                          size="small"
                          href={button.href}
                          component="a"
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={styles.button}
                        >
                          {button.text}
                        </Button>
                      ))
                    ) : (
                      <Button
                        variant="contained"
                        size="small"
                        href={action.href}
                        onClick={action.onClick}
                        component="a"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={styles.button}
                      >
                        {action.buttonText}
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      <Box sx={styles.image}>
        <img src={`${process.env.PUBLIC_URL}/welcome.jpg`} alt="Welcome" />
      </Box>
    </Box>
  );
};

export default EmptyReports;
